'use client';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import Container from "@/components/core/container";
import Section from "@/components/core/section";
import Text from "@/components/core/text";
import { StylizedHeading } from "@/components/core/heading";
import { Project } from "@/models/project";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

interface Props {
    project: Project,
}

export default function ProjectHero({ project }: Props) {

    const tl = useRef<gsap.core.Timeline>(null);
    const container = useRef<HTMLDivElement>(null);

    useGSAP(() => {
        tl.current = gsap.timeline();

        gsap.set(container.current!.children, { autoAlpha: 0, y: 200 });

        tl.current
            .to(container.current!.children, { autoAlpha: 1, y: 0, stagger: 0.1 });

    }, { scope: container, dependencies: [] });

    return (
        <Section background_image={project.hero_image} background_color="secondary" background_mix="overlay" background_opacity={75}>
            <Container ref={container} className="relative z-20 h-screen flex flex-col justify-end space-y-4 pb-32">
                <div className="space-y-4">
                    <StylizedHeading as="h1" size="5xl" fit={true} content={project.client.title ?? ""}/>
                    <div className="max-w-screen-md pr-2 sm:pr-0 space-y-4">
                        <Text size="5xl" color="white" weight="bold" content={project.client.blurb} />
                        <div className="flex flex-wrap gap-2">
                            {project.services.map(service =>
                                <span key={service.id} className="bg-primary text-white rounded-md leading-tight text-sm md:text-base px-2 md:px-4 py-2">{service.title}</span>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
            <div className="absolute top-0 left-0 z-10 w-full h-full bg-gradient-to-t from-secondary"></div>
        </Section>
    );
}